export default __webpack_public_path__ + "static/media/Freezing.67e69cd9.svg";